/**
 * 어떤 플로우 문서가 어떤 prefill 을 필요로 하는가 — 선언 테이블.
 *
 * 레거시에서는 이 지식이 어댑터마다 흩어져 있었다. `CounselStartPage` 가 주문에서
 * 주소를 꺼내 `_prefillAddress` 로 넘기고, 각 step 어댑터가 상담 스냅샷을 꺼내
 * `initialValues` 를 만들었다. 문서만 봐서는 "이 화면이 무엇으로 채워지는가" 를 알 수
 * 없었고, 그래서 프리뷰에서는 늘 빈 폼이 떴다 (건물명이 안 채워지던 이유).
 *
 * 문서 id 로 걸어 두는 이유: 프로덕션 문서는 Firestore 에 저장된 v1 이라 `data` 필드를
 * 품을 수 없다. 문서가 v2 로 저장되기 시작하면 이 표는 각 문서 안으로 흡수되고 여기서
 * 사라진다.
 */

import type { DataSource } from '@miso/design-system';

import {
  ARRIVAL_ADDRESS_PREFILL_DATA,
  DEPARTURE_PREFILL_DATA,
  transportPrefillData,
} from './prefill';

/** 문서 id → 그 화면이 열릴 때 채워질 값. */
export const FLOW_PREFILL_DATA: Record<string, DataSource[]> = {
  'counsel-start-flow': DEPARTURE_PREFILL_DATA,
  'progress-arrival-address': ARRIVAL_ADDRESS_PREFILL_DATA,
  'progress-departure-transport': transportPrefillData('departure'),
  'progress-arrival-transport': transportPrefillData('arrival'),
};

export function flowPrefillData(flowId: string): DataSource[] | undefined {
  return FLOW_PREFILL_DATA[flowId];
}
